import { Moment } from 'moment';
import User from '@/shared/models/User';

export interface KeyboxId {__keyboxId: number}

export default class Keybox {
  id!: KeyboxId;
  locationReference = '';
  locationDescription = '';
  isKeyAvailable = false;
  actionOn!: Moment;
  actionBy: User | null = null;
}
